<div class="paiement-web-container min-h-screen bg-gradient-to-br">
  <div class="chapeau-background"></div>
  <app-loader [isLoading]="isLoading"></app-loader>

  <!-- Titre -->
  <div class="contine title-with-hat">
    <app-page-title [titleKey]="'payments.title'"></app-page-title>
  </div>

  <!-- Sélecteur d'enfants partagé -->
  <app-children-selector [(selectedStudentId)]="selectedStudentId" (studentSelected)="onStudentSelected($event)"></app-children-selector>
  <!-- Segmented control (Payé / Non Payé / Reçu) -->
  <div class="segmented">
    <button class="segment" *ngFor="let tab of tabs; let i = index" (click)="selectTab(i)" [class.active]="selectedTab === i">
      {{ ('payments.' + tab.toLowerCase()) | translate }}
    </button>
  </div>

  <div class="content-card mt-8">
    <!-- Payé: show only when selectedTab === 0 -->
    <section *ngIf="selectedTab === 0" class="pt-8">
      <!-- Section title for Payé -->
      <div class="month-header mb-2">
        <div class="month-title font-semibold text-gray-800">Payé</div>
        <div class="confirmation-icon text-green-500 text-xl">✓</div>
      </div>
      <div *ngIf="!hasPaidPayments()" class="no-data-message">{{ 'payments.noData' | translate }}</div>
      
      <!-- Grid layout for monthly tables (3 columns) -->
      <div *ngIf="hasPaidPayments()" class="space-y-4">
        <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div *ngFor="let month of getMonths('Payé')" class="payment-table-wrapper bg-white rounded-lg shadow p-4">
            <div class="month-header mb-3">
              <div class="month-title font-semibold text-gray-800">{{ formatMonthDisplay(month) }}</div>
              <div class="confirmation-icon text-green-500 text-xl">✓</div>
            </div>
            <table class="payment-table w-full text-sm">
              <thead>
                <tr>
                  <th class="text-left font-semibold text-gray-700 pb-2">{{ 'payments.paymentType' | translate }}</th>
                  <th class="text-right font-semibold text-gray-700 pb-2">{{ 'payments.amount' | translate }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let p of getPaymentsForMonth('Payé', month)" class="border-b">
                  <td class="py-1">{{ p.label }}</td>
                  <td class="text-right py-1">{{ p.amount != null ? p.amount : '—' }}</td>
                </tr>
                <tr class="month-total-row font-bold bg-gray-50">
                  <td class="total-label py-2">{{ 'payments.total' | translate }}</td>
                  <td class="total-value text-right py-2 text-green-600">{{ getMonthTotal('Payé', month) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>

    <!-- Non Payé: show only when selectedTab === 1 -->
    <section *ngIf="selectedTab === 1" class="pt-8">
      <!-- Section title for Non Payé -->
      <div class="month-header mb-2">
        <div class="month-title font-semibold text-gray-800">Non Payé</div>
        <div class="confirmation-icon2 text-red-500 text-xl">!</div>
      </div>
      <div *ngIf="!hasUnpaidPayments()" class="no-data-message">{{ 'payments.noData' | translate }}</div>
      
      <!-- Grid layout for monthly tables (3 columns) -->
      <div *ngIf="hasUnpaidPayments()" class="space-y-4">
        <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div *ngFor="let month of getMonths('Non Payé')" class="payment-table-wrapper bg-white rounded-lg shadow p-4">
            <div class="month-header mb-3">
              <div class="month-title font-semibold text-gray-800">{{ formatMonthDisplay(month) }}</div>
              <div class="confirmation-icon2 text-red-500 text-xl">!</div>
            </div>
            <table class="payment-table w-full text-sm">
              <thead>
                <tr>
                  <th class="text-left font-semibold text-gray-700 pb-2">{{ 'payments.paymentType' | translate }}</th>
                  <th class="text-right font-semibold text-gray-700 pb-2">{{ 'payments.amount' | translate }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let p of getPaymentsForMonth('Non Payé', month)" class="border-b">
                  <td class="py-1">{{ p.label }}</td>
                  <td class="text-right py-1">{{ p.amount != null ? p.amount : '—' }}</td>
                </tr>
                <tr class="month-total-row font-bold bg-gray-50">
                  <td class="total-label py-2">{{ 'payments.total' | translate }}</td>
                  <td class="total-value text-right py-2 text-red-600">{{ getMonthTotal('Non Payé', month) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>

    <!-- Reçu: show only when selectedTab === 2 -->
    <section *ngIf="selectedTab === 2" class="pt-8">
      <div *ngIf="getMonths('Reçu').length === 0" class="no-data-message">{{ 'payments.noData' | translate }}</div>
      <div *ngFor="let month of getMonths('Reçu')" class="payment-table-wrapper receipt-wrapper">
        <div class="month-header">
          <div class="month-title">{{ formatMonthDisplay(month) }}</div>
          <div class="confirmation-icon">📄</div>
        </div>
        <table class="payment-table w-full">
          <thead>
            <tr>
              <th>Numéro reçu</th>
              <th>Date</th>
              <th>Montant (DT)</th>
              <th class="actions-col">{{ 'actions.actions' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let p of paginatedReceiptsTable()" class="border-b hover:bg-gray-50">
              <td>{{ p.receiptNumber || p.id || cleanReceiptLabel(p.label) }}</td>
              <td>{{ p.date ? (p.date | date:'shortDate') : '—' }}</td>
              <td>{{ p.amount != null ? p.amount : '—' }}</td>
              <td>
                <button (click)="downloadPDF(p.pathFile || '', p.label || 'recu.pdf', p)" class="px-3 py-1 bg-[#49BBBD] text-white rounded hover:bg-[#3aa3a5] disabled:opacity-50 disabled:cursor-not-allowed" [disabled]="!p.pathFile">{{ 'payments.download' | translate }}</button>
              </td>
            </tr>
            <tr *ngIf="getReceiptsForStudent().length === 0"><td colspan="4" class="text-center py-4">{{ 'payments.noData' | translate }}</td></tr>
          </tbody>
        </table>
        <div class="flex justify-center items-center space-x-2 mt-3">
          <button (click)="previousReceiptsTablePage()" [disabled]="receiptsCurrentPageTable === 1" class="px-3 py-1 rounded bg-gray-100 disabled:opacity-50">‹</button>
          <span>{{ receiptsCurrentPageTable }} / {{ receiptsTotalPagesTable() }}</span>
          <button (click)="nextReceiptsTablePage()" [disabled]="receiptsCurrentPageTable === receiptsTotalPagesTable()" class="px-3 py-1 rounded bg-gray-100 disabled:opacity-50">›</button>
        </div>
      </div>
    </section>
  </div>
</div>




